import { ReactNode } from 'react';
import { faQuestionCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Tooltip from 'components/tooltip';

interface AuctionTooltipContentProps {
    children?: ReactNode;
    className?: string;
}

interface AuctionTooltipTriggerProps {
    className?: string;
}

const AuctionTooltip = Tooltip.Root;

const AuctionTooltipContent = (props: AuctionTooltipContentProps) => {
    const { children, className = '' } = props;

    return (
        <Tooltip.Portal>
            <Tooltip.Content
                className={`!bg-black !px-3 !py-2 text-xs font-normal !text-white ${className}`}
            >
                {children}
                <Tooltip.Arrow className={'!fill-current'} />
            </Tooltip.Content>
        </Tooltip.Portal>
    );
};

const AuctionTooltipTrigger = (props: AuctionTooltipTriggerProps) => {
    const { className = '' } = props;
    return (
        <Tooltip.Trigger
            asChild={true}
            tabIndex={0}
            className={`cursor-help text-gray-500 ${className}`}
        >
            <FontAwesomeIcon icon={faQuestionCircle} />
        </Tooltip.Trigger>
    );
};

const Root = AuctionTooltip;
const Content = AuctionTooltipContent;
const Trigger = AuctionTooltipTrigger;

export {
    AuctionTooltip,
    AuctionTooltipContent,
    AuctionTooltipTrigger,
    //
    Root,
    Content,
    Trigger,
};

export type { AuctionTooltipContentProps };
